<div class="container mt-4">
  <div *ngIf="deleting" class="backdrop">
    <div class="spinner-border text-light" role="status">
      <span class="visually-hidden">Salvando as Informações...</span>
    </div>
  </div>

  <div class="page-header mb-4">
    <h1 class="page-title">Lista de Funcionários</h1>
  </div>

  <div class="text-end mb-3" *ngIf="employeeData.length > 0 && !loading && isAdmin">
    <button class="btn btn-primary" (click)="router.navigate(['/employees/create'])" data-cy="create-employee-button">
      Criar Novo Funcionário
    </button>
  </div>

  <div *ngIf="loading" class="alert alert-info" data-cy="loading-message">Carregando funcionários...</div>

  <app-zebra-employee-table
    *ngIf="!loading && employeeData.length != 0"
    [headers]="employeeHeaders"
    [data]="employeeData"
    [itemsPerPage]="5"
    [isAdmin]="isAdmin"
    [isManager]="isManager"
    [isSupervisor]="isSupervisor"
    [isUser]="isUser"
    (edit)="onEdit($event)"
    (delete)="onDelete($event)"
    (view)="onView($event)"
  ></app-zebra-employee-table>

  <div *ngIf="!loading && employeeData.length == 0" data-cy="empty-state">
    <img src="../../../../../assets/img/folder.png" alt="empty" class="empty" />
    <h4 data-cy="empty-message">Nenhum funcionário cadastrado.</h4>

    <ng-container *ngIf="!isAdmin; then askAdminToCreate; else showCreateEmployeeButton"></ng-container>
    <ng-template #askAdminToCreate>
      <p data-cy="ask-admin-message">Peça ao Administrador para cadastrar!</p>
    </ng-template>
    <ng-template #showCreateEmployeeButton>
      <button
        class="btn btn-primary"
        (click)="router.navigate(['/employees/create'])"
        data-cy="create-employee-button-empty"
      >
        Criar Novo Funcionário
      </button>
    </ng-template>
  </div>
</div>
